import * as React from 'react';
import {Button} from "@progress/kendo-react-buttons";

export const CaButton = (props) => {
    return <Button {...props} className={"CaPrimaryButton"}/>
}